import React from "react";
import { useStoreState } from "easy-peasy";
import { Select } from "@cofano/cck";

const RelationContactTypeSelect = ({ value, onChange }) => {

	const { settings } = useStoreState(store => store.session);

	const contactTypes = settings?.multiValues?.customerContactTypes?.split(";") || [];

	const options = contactTypes.map(type => ({
		id: type,
		name: type,
	}));

	return (
		<Select
			fetchOptions={options}
			value={options.find(option => option.id === value)}
			onChange={(option) => onChange(option.id)}
			clearable={true}
			disableSearch />
	);
};

export default RelationContactTypeSelect;
